import Image from "next/image";
import Link from "next/link";

const Logo: React.FC = () => {
  return (
    <Link href="/" className="inline-block">
      <Image
        src="/images/logo/logo.png"
        alt="logo"
        width={280}
        height={50}
        priority
        className="w-full h-12 object-contain"
      />
    </Link>
  );
};

export default Logo;
